(function () {
  var quizBase = 'https://quiz.thememorymelody.com/quiz';
  var cookieName = 'tmm_quiz_query';
  var rawQuery = window.location.search.length > 1 ? window.location.search.slice(1) : '';

  if (rawQuery) {
    document.cookie = cookieName + '=' + encodeURIComponent(rawQuery) + '; path=/; max-age=2592000; SameSite=Lax';
  }

  function savedQuery() {
    var parts = document.cookie.split('; ');
    for (var index = 0; index < parts.length; index += 1) {
      if (parts[index].indexOf(cookieName + '=') === 0) {
        try {
          return decodeURIComponent(parts[index].slice(cookieName.length + 1));
        } catch (error) {
          return '';
        }
      }
    }
    return '';
  }

  function applyQuizLinks() {
    var query = savedQuery();
    var destination = quizBase + (query ? '?' + query : '');
    document.querySelectorAll('a[data-tmm-quiz]').forEach(function (link) {
      link.setAttribute('href', destination);
      link.removeAttribute('target');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyQuizLinks);
  } else {
    applyQuizLinks();
  }

  document.addEventListener('shopify:section:load', applyQuizLinks);
  new MutationObserver(applyQuizLinks).observe(document.documentElement, { childList: true, subtree: true });
})();
